<template>
  <Modal :value="true" title="布卷详情" :width="1100" :mask-closable="false" @on-cancel="$emit('close')">
    <div class="fabric-detail">
      <div class="detail-toolbar">
        <span>仅显示已同步数据；时间为北京时间</span>
        <Button :loading="loading" icon="md-refresh" @click="load">刷新</Button>
      </div>
      <Alert v-if="error" type="error" show-icon>{{ error }}</Alert>
      <div v-if="loading && !fabric" class="loading-placeholder">正在加载布卷与分段…</div>
      <template v-if="fabric">
        <div class="roll-heading"><h2>{{ fabric.rollNo || fabric.fabricNo || '布卷' }}</h2><Tag :color="fabric.status === 'ACTIVE' ? 'blue' : fabric.status === 'FINISHED' ? 'green' : 'default'">{{ statusName(fabric.status) }}</Tag></div>
        <div class="roll-counts">
          <div><span>累计圈数</span><strong>{{ display(fabric.totalRounds) }}</strong></div>
          <div><span>人员分段</span><strong>{{ display(fabric.segmentCount) }}</strong></div>
          <div><span>已上传瑕疵</span><strong>{{ display(fabric.uploadedDefectCount) }}</strong></div>
        </div>
        <dl class="roll-profile">
          <div v-for="item in profile" :key="item.title"><dt>{{ item.title }}</dt><dd>{{ item.value }}</dd></div>
        </dl>
        <div class="segment-heading"><h3>人员分段</h3><span>按生产圈数排序 · {{ total }} 段</span></div>
        <SegmentTable :key="`${context}:${page}:${pageSize}`" :rows="segments" :total="total" :loading="loading" :no-data-text="fabric.status === 'READY' ? '尚未开始生产，暂无分段' : '暂无已同步分段'" />
        <div class="detail-pagination"><Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[20, 50, 100]" show-sizer @on-change="changePage" @on-page-size-change="changePageSize" /></div>
      </template>
    </div>
    <div slot="footer"><Button @click="$emit('close')">关闭</Button></div>
  </Modal>
</template>

<script>
import { fabricDetail, fabricSegments, productionData, productionError } from '@/api/production'
import segmentPresentation from './segment-presentation'
import SegmentTable from './segment-table.vue'

export default {
  name: 'FabricDetail',
  components: { SegmentTable },
  mixins: [segmentPresentation],
  props: {
    factoryId: { type: Number, required: true },
    fabricId: { type: String, required: true }
  },
  data () {
    return { fabric: null, segments: [], total: 0, page: 1, pageSize: 20, loading: false, error: '', sequence: 0 }
  },
  computed: {
    context () { return `${this.factoryId}:${this.fabricId}` },
    profile () {
      const row = this.fabric || {}
      return [
        { title: '布号', value: this.display(row.fabricNo) },
        { title: '布料类型', value: this.display(row.fabricType) },
        { title: '订单号', value: this.display(row.orderNo) },
        { title: '批次号', value: this.display(row.batchNo) },
        { title: '颜色', value: this.display(row.colorName) },
        { title: '生产设备', value: this.display(row.latestDeviceName || row.latestDevicePort) },
        { title: '开始时间', value: row.startedAt ? this.time(row.startedAt) : '尚未开始' },
        { title: '结束时间', value: row.endedAt ? this.time(row.endedAt) : row.status === 'READY' ? '—' : '尚未结束' }
      ]
    }
  },
  watch: {
    context () { this.page = 1; this.load() }
  },
  mounted () { this.load() },
  beforeDestroy () { this.sequence++ },
  methods: {
    display (value) { return value === null || value === undefined || value === '' ? '—' : value },
    changePage (page) { this.page = page; return this.load() },
    changePageSize (size) { this.pageSize = size; this.page = 1; return this.load() },
    async load () {
      const sequence = ++this.sequence
      this.fabric = null; this.segments = []; this.total = 0; this.error = ''
      if (!this.factoryId || !this.fabricId) { this.loading = false; return }
      this.loading = true
      try {
        const [fabric, segments] = await Promise.all([
          fabricDetail(this.factoryId, this.fabricId).then(productionData),
          fabricSegments(this.factoryId, this.fabricId, { page: this.page, pageSize: this.pageSize }).then(productionData)
        ])
        if (sequence !== this.sequence) return
        this.fabric = fabric; this.segments = segments.items || []; this.total = Number(segments.total) || 0
      } catch (error) {
        if (sequence === this.sequence) this.error = productionError(error)
      } finally { if (sequence === this.sequence) this.loading = false }
    }
  }
}
</script>

<style scoped>
.detail-toolbar, .roll-heading, .segment-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 16px; }
.detail-toolbar > span, .segment-heading > span, .roll-profile dt { color: #808695; }
.loading-placeholder { padding: 50px; text-align: center; color: #808695; }
.roll-heading h2 { font-size: 22px; overflow-wrap: anywhere; }
.roll-counts { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; background: #f5f7fa; border-radius: 8px; padding: 18px; }
.roll-counts strong { display: block; font-size: 26px; color: #17233d; margin-top: 5px; }
.roll-profile { display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px 24px; margin: 20px 0 26px; }
.roll-profile > div { display: flex; gap: 12px; }
.roll-profile dt { min-width: 70px; }
.roll-profile dd { margin: 0; overflow-wrap: anywhere; }
.detail-pagination { text-align: right; margin-top: 18px; }
@media (max-width: 700px) { .roll-profile { grid-template-columns: 1fr; } }
</style>
